var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHoi = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.411 39.4111C39.411 21.7054 67.2339 21.7056 67.2339 39.4111C67.2339 52.0579 54.5872 49.528 54.5872 64.7041",
    stroke: "black",
    strokeWidth: 7.58807,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5872 84.99L54.6377 84.9338",
    stroke: "black",
    strokeWidth: 7.58807,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5871 105.174C82.5254 105.174 105.174 82.5254 105.174 54.5871C105.174 26.6486 82.5254 4 54.5871 4C26.6486 4 4 26.6486 4 54.5871C4 63.8011 6.46344 72.4398 10.7676 79.8807L6.52936 102.645L29.2936 98.4067C36.7343 102.711 45.3732 105.174 54.5871 105.174Z",
    stroke: "black",
    strokeWidth: 7.58807,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHoi, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hoi.3f4858ee.svg";
export { ForwardRef as ReactComponent };